// https://app.growthbook.io/features/pen-5921_v1
export const GIFT_PAGE_REDESIGN_FLAG_NAME = 'pen-5921_v1'
